
import { mapGetters, mapMutations, mapActions } from 'vuex'
import formValidation from "@/mixins/formValidation";
import filters from "@/mixins/filters";
import checkboxManagerMixin from '@/mixins/checkboxManager';

export default {
	mixins: [formValidation, filters, checkboxManagerMixin],
	props: {
		hasChose: {
			type: Boolean,
			default: true
		},
		offer: Object
	},
	data() {
		return {
			localModal: false,
			totalChange: '0 ₽/мес',
			creditParams: {
				rangePeriodValues: [
					"2",
					"6",
					"12",
					"24",
					"36",
					"48",
					"60",
					"72",
					"84",
					"96"
				],
				rangePaymentValues: [
					'0%',
					'10%',
					'20%',
					'30%',
					'40%',
					'50%',
					'60%',
					'70%',
					'80%',
				],
				period: 96,
				payment: 0,
			}
		}
	},
	computed: {
		currentCar() {
			if (this.offer) return this.offer
		},
		...mapGetters({
			// currentCar: 'modal/modal-choose/currentCar',
			bank: 'banks/bank',
			settings: 'settings/settings/settings',
			activeModal: 'modal/modal-main/modal',
		}),
		percent() {
			// Динамично меняет процентную ставку в зависимости от банка
			// return this.bank.rate ? this.bank.rate : this.$config.default_percent
			return this.$config.default_percent
		},
		formProgress() {
			let progress = 30
			if (this.currentCar || this.offer) {
				progress += 30
			}
			if (this.name_valid) {
				progress += 10
			}
			if (this.date_valid) {
				progress += 10
			}
			if (this.phone_valid) {
				progress += 10
			}
			if (this.form.agree) {
				progress += 4
			}
			if (this.form.agreeRf) {
				progress += 4
			}
			return progress
		},
		currentDealer() {
			if (this.offer) {
				return this.offer.dealer
			} else if (this.currentCar) {
				return this.currentCar.dealer
			}
		}
	},
	methods: {
		onFocus() {
			this.setFocusShowFixes(false)
		},
		onFocusOut() {
			setTimeout(() => {
				this.setFocusShowFixes(true)
			}, 1000)
		},
		...mapActions({
			openModal: 'modal/modal-main/openModal',
			closeModal: 'modal/modal-main/closeModal',
			sendForm: 'form/form/sendForm'
		}),
		...mapMutations({
			setPercent: 'banks/SET_PERCENT',
			setCurrentCar: 'form/form-credit/SET_CURRENT_CAR',
			setFocusShowFixes: 'car/car/SET_FOCUS_SHOW_FIXED'

		}),
		choseCar() {
			this.error = ''
			let payload = {
				modal_component: 'modal-choose',
				modal_title: 'Выберите автомобиль',
				modal_sub_title: '10 560 автомобилей в наличии'
			}
			this.openModal(payload)
		},
		checkForm() {
			if (this.hasChose) {
				if (!this.currentCar) {
					this.error = 'invalid_car'
					setTimeout(function () { window.scrollTo(0, -100); }, 1);
					return false
				}
			}
			if (this.form.name.value.length < 2) {
				this.form.name.valid = false
				return false
			}
			// if (this.form.date.value === '' || this.form.date.value.split('_').length > 1) {
			// 	this.form.date.valid = false
			// 	return false
			// }
			// let nowDate = Number(new Date().getFullYear()) - 21;
			// if (Number(this.form.date.value.split('/')[0]) > 32 || Number(this.form.date.value.split('/')[1]) > 13
			// 	|| Number(this.form.date.value.split('/')[2]) > nowDate || Number(this.form.date.value.split('/')[2]) < 1900) {
			// 	this.form.date.valid = false
			// 	return false
			// }
			if (!this.form.phone.valid) {
				this.form.phone.valid = false
				return false
			}
			const checkboxesValid = this.validateCheckboxes();
      if (!checkboxesValid) {
        return false;
      }
			return true;
		},
		async credit() {
			let payload = {
				modal_data: this.offer,
				modal_component: 'modal-credit',
				modal_title: 'Заявка на автокредит',
				modal_sub_title: this.offer.name
			}
			await this.openModal(payload)

			// this.$router.push({
			// 	path: '/credit', query: {
			// 		mark: this.offer.mark.slug,
			// 		model: this.offer.folder.slug,
			// 		car: this.offer.external_id
			// 	}
			// })
		},
		async submitForm() {
			if (this.checkForm()) {

				let formData = {
					chosen_car: this.currentCar || this.offer, //нужно для страницы thanks
					external_id: this.hasChose ? this.currentCar.external_id : this.offer.external_id,
					type: 'credit',
					dealer: this.currentDealer.slug,
					client_name: this.form.name.value,
					client_phone: this.form.phone.value,
					// client_age: this.form.date.value,
					credit_initial_fee: this.form.paymentValue.toString(),
					credit_period: this.form.periodValue.toString() + " мес.",
				}
				// utm
				if (localStorage.utm_source) {
					formData.utm_source = localStorage.utm_source
				}
				if (localStorage.utm_medium) {
					formData.utm_medium = localStorage.utm_medium
				}
				if (localStorage.utm_campaign) {
					formData.utm_campaign = localStorage.utm_campaign
				}
				if (localStorage.utm_term) {
					formData.utm_term = localStorage.utm_term
				}
				if (localStorage.utm_content) {
					formData.utm_content = localStorage.utm_content
				}
				await this.sendForm(formData)
				await this.closeModal()
			}
		}
	},

}
